export enum WidgetOwner {
  PARTNER = 'Partner',
  CHARITY = 'Charity',
  ORGANIZATION = 'Organization',
}